import styled from 'styled-components'

export const Article = styled.div`
  position: relative;
  width: 100%;
  transition: background 0.2s;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 0 1.6rem;
  }

  a {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    color: ${props => props.theme.colors.base};
    text-decoration: none;

    .gatsby-image-wrapper {
      height: 0;
      padding-bottom: 60%;
    }

    &:after {
      content: none;
    }
  }

  &:hover {
    h5 {
      text-decoration: underline;
      color: ${props => props.theme.colors.cobalt};
    }
  }
`

export const Title = styled.h5`
  text-transform: capitalize;
  margin: 1.6rem 0;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    min-height: 6rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    min-height: auto;
  }
`

export const Excerpt = styled.p`
  font-size: 1.4rem;
  padding: 1.6rem 0;
  line-height: 1.7;
  border-bottom: 1px solid ${props => props.theme.colors.black};
  /* To maintain a consistent height even if the excerpt is smaller than 160 characters. */
  min-height: 15.4rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    min-height: 10.8rem;
  }
`

export const Category = styled.p`
  font-size: 1.4rem;
  color: ${props => props.theme.colors.brownGrey};
  font-weight: 300;
  margin-top: 0.4rem;
  line-height: 2;
`
